<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_v"><em>Contents</em></a></h2><a id="page_v">
</a><p class="toc1"><a id="page_v"></a><a href="#/xhtml/intro#intro" id="tocintro">Introduction</a></p>
<p class="toc1"><a href="#/xhtml/ch01#ch01" id="tocch01">“A <em>Stranger</em> Amongst <em>Strangers</em>”: Who Were the Subassistant Commissioners?</a></p>
<p class="toc1"><a href="#/xhtml/ch02#ch02" id="tocch02">“The Post of Greatest Peril”: The E. M. Gregory Era, September 1865–April 1866</a></p>
<p class="toc1"><span href="#/xhtml/ch03#ch03" id="tocch03" title="Link target outside of Sample">Conservative Phoenix: The J. B. Kiddoo Era, May 1866–Summer 1866</span></p>
<p class="toc1"><span href="#/xhtml/ch04#ch04" id="tocch04" title="Link target outside of Sample">Bureau Expansion, Bureau Courts, and the Black Code: The J. B. Kiddoo Era, Summer 1866–November 1866</span></p>
<p class="toc1"><span href="#/xhtml/ch05#ch05" id="tocch05" title="Link target outside of Sample">The Bureau’s Highwater Mark: The J. B. Kiddoo Era, November 1866–January 1867</span></p>
<p class="toc1"><span href="#/xhtml/ch06#ch06" id="tocch06" title="Link target outside of Sample">“They Must Vote with the Party That Shed Their Blood . . . In Giving Them Liberty.” Bureau Agents, Politics, and the Bureau’s New Order: The Charles Griffin Era, January 1867–Summer 1867</span></p>
<p class="toc1"><span href="#/xhtml/ch07#ch07" id="tocch07" title="Link target outside of Sample">Violence, Frustration, and Yellow Fever: The Charles Griffin Era, Summer–Fall 1867</span></p>
<p class="toc1"><span href="#/xhtml/ch08#ch08" id="tocch08" title="Link target outside of Sample">General Orders No. 40 and the Freedmen’s Bureau’s End: The J. J. Reynolds Era, September 1867–December 1868</span></p>
<p class="toc1b"><a id="page_vi"></a><span href="#/xhtml/conclu#conclu" id="tocconclu" title="Link target outside of Sample">Conclusion: The Subassistant Commissioners in Texas</span></p>
<p class="toc2"><span href="#/xhtml/app01#app01" id="tocapp01" title="Link target outside of Sample"><em>Appendix A</em></span></p>
<p class="toc2"><span href="#/xhtml/app02#app02" id="tocapp02" title="Link target outside of Sample"><em>Appendix B</em></span></p>
<p class="toc2"><span href="#/xhtml/notes#notes" id="tocnotes" title="Link target outside of Sample"><em>Notes</em></span></p>
<p class="toc2"><span href="#/xhtml/bib#bib" id="tocbib" title="Link target outside of Sample"><em>Bibliography</em></span></p>
<p class="toc2"><span href="#/xhtml/index#index" id="tocindex" title="Link target outside of Sample"><em>Index</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?4b7daaf0